// angular
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input,
  output,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
// components
import { NoContentComponent } from '@app/core/components/no-content/no-content.component';
import { PaginationComponent } from '@app/core/components/pagination/pagination.component';
import { ProductCardSkeletonComponent } from '@app/core/components/product-card/product-card-skeleton/product-card-skeleton.component';
import { ProductCardComponent } from '@app/core/components/product-card/product-card.component';
import { SortsBarComponent } from '@app/core/components/sorts-bar/sorts-bar.component';
// services
import { ProductsService } from '@app/+products/shared/services/products.service';
// interfaces & constants
import { IProduct } from '@app/+products/shared/interfaces/product.interface';
import { productSortItems } from '@app/+products/shared/constants/product-sort-items';

@Component({
  selector: 'pwj-cards-list',
  standalone: true,
  imports: [
    SortsBarComponent,
    ProductCardComponent,
    PaginationComponent,
    NgxSkeletonLoaderModule,
    NoContentComponent,
    ProductCardSkeletonComponent,
  ],
  templateUrl: './cards-list.component.html',
  styleUrl: './cards-list.component.scss',
})
export class CardsListComponent implements AfterViewInit {
  /** When true, desktop sort bar shows a filters button (md–lg: filters live in a dialog). */
  showFiltersTriggerOnSortBar = input(false);
  filtersFromSortBar = output<void>();

  public listTabs: string[] = productSortItems;
  public products: IProduct[] = [];
  public productsCount: number = 0;
  public isLoading!: boolean;
  public isElasticSearchMode!: boolean;

  // dependencies
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _productService = inject(ProductsService);
  private readonly _cdRef = inject(ChangeDetectorRef);

  constructor() {
    // get loading state
    effect(() => {
      this.isLoading = this._productService.isProductsLoading();
      this._cdRef.detectChanges();
    });

    // set products list data
    effect(() => {
      this.products = this._productService.productsList();
      this._cdRef.detectChanges();
    });

    // set all products count
    effect(() => {
      if (this._productService?.allProductsCount()) {
        this.productsCount = this._productService.allProductsCount() as number;
        this._cdRef.detectChanges();
      }
    });
  }

  ngAfterViewInit(): void {
    this._activatedRoute.queryParams.subscribe(params => {
      // pagination params
      const take = params['perPage'] || 12;
      const skip = params['page'] ? (Number(params['page']) - 1) * take : 0;
      const search = params['search'];
      // sort params
      const sort = params['sort'] || null;
      const specialist_verified = params['specialist_verified'];
      const business_verified = params['business_verified'];

      let selectedParams: Params = {
        ...params,
        take,
        skip,
        sort,
        specialist_verified,
        business_verified,
        page: null,
        perPage: null,
      };

      selectedParams = Object.fromEntries(
        Object.entries(selectedParams).filter(
          ([_, value]) => value && value !== null
        )
      );

      // fetch data with params
      if (!search) {
        this._productService.getAllProducts(selectedParams);
      }
    });
  }
}
